exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.box[data-v-be13db86]{\n  min-height: 100vh;\n  background: #fff;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.myChart[data-v-be13db86]{\n  width: 6rem;\n  height: 6rem;\n}\n.title[data-v-be13db86]{\n  font-size: .3rem;\n  color: #010101;\n  text-align: left;\n  width: 6.9rem;\n  margin-bottom: .3rem;\n}\n.img[data-v-be13db86]{\n  width: 6.79rem;\n  height: 2.66rem;\n  background: url(" + require("assets/lct.png") + ") no-repeat center/cover;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-be13db86","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./src/components/informationDetail.vue
// module id = Hg1H
// module chunks = 1